/**
 *
 */
export var ThemeVariant;
(function (ThemeVariant) {
    ThemeVariant["LIGHT"] = "light";
    ThemeVariant["DARK"] = "dark";
})(ThemeVariant || (ThemeVariant = {}));
